import i18nFactory from '@yandex-int/i18n';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { ValidationErrorData } from '../../typings/common';
import { CurrencyCode } from '../../typings/graphql-public-grid';
import { formatNumber } from '../FormatHelpers/FormatHelpers';

import * as keyset from './CommonPriceEditorHelper.i18n';
const i18n = i18nFactory(keyset);

export interface CommonPriceEditorValidationParams {
    minGeneralPrice: number;
    maxGeneralPrice: number;
    currency: CurrencyCode;
}

export function validateCommonPriceValue(
    value: number,
    validationParams: CommonPriceEditorValidationParams
): ValidationErrorData[] {
    const errors = [];

    if (value === undefined || value < validationParams.minGeneralPrice) {
        errors.push({
            text: i18n('single-rate-min-price', {
                minValue: formatNumber(validationParams.minGeneralPrice),
                currency: mapStringToCurrencySymbol(validationParams.currency)
            })
        });
    } else if (value > validationParams.maxGeneralPrice) {
        errors.push({
            text: i18n('single-rate-max-price', {
                maxValue: formatNumber(validationParams.maxGeneralPrice),
                currency: mapStringToCurrencySymbol(validationParams.currency)
            })
        });
    }

    return errors;
}
